import {useEffect, useMemo, useState} from "react";
import {
    Box,
    Button,
    Grid,
    Group,
    Loader,
    LoadingOverlay,
    Text,Card,
    Title, Paper
} from "@mantine/core";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import MaterialReactTable, {
    MaterialReactTableProps,
    MRT_Cell,
    MRT_ColumnDef,
    MRT_Row,
} from 'material-react-table';
type WpsPropsTypes = {
    pendingListData: any;
};
import {Link, generatePath} from "react-router-dom";


import {
    Tooltip,
    IconButton,
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';

const PendingList = ({pendingListData}: WpsPropsTypes) => {

    const handleViewClick = (e:any) => {

        //   console.log(e)

   //     dispatch(setCustomerState(e));

        // id = e
        // console.log(id)
    };
    

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'Supplier',
                header: 'Code',
                Cell: ({cell, table, row}) => {
                    var Main_Account: any = row.original['SUPPRH_NO'] ? row.original['SUPPRH_NO']  : ''
                    var name: any = row.original.SUPPRH_SUPP_NAME ? row.original.SUPPRH_SUPP_NAME : '-'
                    return (<div>
                        {Main_Account && (<Text fw={500}>{Main_Account}</Text>)}
                        {name && (
                            <Text fw={500}>{name}</Text>)}
                    </div>)
                },
            },
            {
                accessorKey: 'Email',
                header: 'Email',
                Cell: ({cell, table, row}) => {
                    var Department: any = row.original.SUPPRH_EMAIL_ID ? row.original.SUPPRH_EMAIL_ID : '-'
                    var phone: any = row.original.SUPPRH_SUPP_TEL1 ? row.original.SUPPRH_SUPP_TEL1 : '-'
                    return (<div>
                        {Department && (   <Text fw={500}>{Department}</Text>)}
                        {phone && (  <Text fw={500}>{phone ? phone : '-'}</Text>)}
                    </div>)
                },
            },

            {
                accessorKey: 'Bank',
                header: 'Bank',
                Cell: ({cell, table, row}) => {
                    var SUPPRH_BANK_NAME: any = row.original['SUPPRH_AC_NO'] ? row.original['SUPPRH_AC_NO'] : ''
                    var SUPPRH_BANK_CODE: any = row.original['SUPPRH_BANK_CODE'] ? row.original['SUPPRH_BANK_CODE'] : ''
                    var SUPPRH_BRANCH_NAME: any = row.original['SUPPRH_BRANCH_NAME'] ? row.original['SUPPRH_AC_NO'] : ''
                    return (<div>
                        {SUPPRH_BANK_NAME && (
                            <Text fw={500}>Name:{SUPPRH_BANK_NAME}</Text>)}
                        {SUPPRH_BANK_CODE && (
                            <Text fw={500}>Code:{SUPPRH_BANK_CODE}</Text>)}

                        {SUPPRH_BRANCH_NAME && (
                            <Text fw={500}>Branch:{SUPPRH_BRANCH_NAME}</Text>)}

                    </div>)
                },
            },

            {
                accessorKey: 'Status',
                header: 'Status',
                Cell: ({cell, table, row}) => {
                    var SUPPRH_STATUS: any = row.original['SUPPRH_STATUS'] ? row.original['SUPPRH_STATUS'] : ''
                    // var Local_Amount: any = row.original['Local Amount'] ? row.original['Local Amount'] : '0'
                    return (<div>
                        {SUPPRH_STATUS && (
                            <Text fw={500}>{SUPPRH_STATUS}</Text>)}
                        {/*{Local_Amount && (*/}
                            {/*<Text fw={500}>Local Amount:{Local_Amount}</Text>)}*/}
                    </div>)
                },
            },
        ],
        [],
    );


    return (
        <>

            <Card  shadow="sm"  radius="md" withBorder mt={'30px'}>


                {/*<Card.Section withBorder inheritPadding py="lg" mb="sm">*/}

                {/*</Card.Section>*/}


                {pendingListData ? (
                    <ThemeProvider theme={createTheme({})}>
                        <Paper mt='15px' sx={{width: "100%"}}>
                            <MaterialReactTable
                                muiTableBodyProps={{
                                    sx: (theme) => ({
                                        '& tr:nth-of-type(odd)': {
                                            backgroundColor: '#fff',
                                        },
                                        '& tr:nth-of-type(even)': {
                                            backgroundColor: '#fff',
                                        },
                                    }),
                                }}
                                // enableColumnActions={false}
                                // enableColumnFilters={false}
                                // enableTopToolbar={false}
                                // enableColumnDragging ={false}
                                muiBottomToolbarProps={{
                                    sx: {
                                        height: '100px',
                                        backgroundColor: '#fff',
                                        fontWeight: '500',
                                        fontSize: '15px',
                                        color: 'rgb(34, 51, 84)'
                                    }
                                }}
                        
                                muiTableHeadCellProps={{
                                    sx: (theme) => ({
                                        backgroundColor: '#2e439e', color: '#fff', fontSize: '14px'
                                    }),
                                }}
                                columns={columns}
                                data={pendingListData}
                                // enableColumnActions={false}
                                enableColumnFilters={false}
                                //  enablePagination={false}
                                enableSorting={false}
                                //    enableBottomToolbar={false}
                                enableTopToolbar={false}
                                muiTableBodyRowProps={{hover: false}}
                                initialState={{
                                    pagination: {pageIndex: 0, pageSize: 10},
                                    columnVisibility: {redemption_id: false}
                                }}
                                positionActionsColumn="last"

                                enableRowActions
                                renderRowActions={({ row, table }) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                                        <IconButton
                                            color="secondary"
                                            // onClick={() => {
                                            //     table.setEditingRow(row);
                                            // }}
                                            >
                                            <Link   to={generatePath("/supplier/view/:id", {id: row.original['SUPPRH_ID']})}>
                                            <VisibilityIcon/>
                                                </Link>
                                        </IconButton>
                                    </Box>
                                )}

                            />
                        </Paper>
                    </ThemeProvider>
                ) : null}

            </Card>
        </>
    );
};

export default PendingList;
